import { render, staticRenderFns } from "./Image.vue?vue&type=template&id=6d087498&scoped=true&"
import script from "./Image.vue?vue&type=script&lang=js&"
export * from "./Image.vue?vue&type=script&lang=js&"
import style0 from "./Image.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Image.vue?vue&type=style&index=1&id=6d087498&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d087498",
  null
  
)

export default component.exports